import {
  PartnerOrdersCatalogFilter,
  type TenantPartnerOrdersSummary,
} from "@/types/partner-order";

export interface PartnerOrdersTotals {
  count: number;
  /** Booked (guest price), not commission. Excludes cancelled/refunded orders (backend EARNING_EXCLUDED_STATUSES); null when currencies are mixed. */
  revenue: number | null;
  currency: string | null;
  mixedCurrency: boolean;
}

const round2 = (value: number): number => Math.round(value * 100) / 100;

/**
 * Total shown above the tenant orders table, scoped to the selected catalog
 * filter. Count and revenue both come from the summary, so they cover one
 * set of orders: cancelled and refunded are in neither (DV-72). The table
 * still lists every row, with its status.
 */
export function getPartnerOrdersTotals(
  catalog: PartnerOrdersCatalogFilter,
  summary: TenantPartnerOrdersSummary | null | undefined,
): PartnerOrdersTotals | null {
  if (!summary) {
    return null;
  }
  const out = summary.outOfCatalog;
  let revenue: number;
  let count: number;
  if (catalog === PartnerOrdersCatalogFilter.OUT) {
    revenue = out.booked;
    count = out.count;
  } else if (catalog === PartnerOrdersCatalogFilter.IN) {
    revenue = round2(summary.totalRevenue - out.booked);
    count = summary.totalOrders - out.count;
  } else {
    revenue = summary.totalRevenue;
    count = summary.totalOrders;
  }
  if (summary.currency === "MIXED") {
    return { count, revenue: null, currency: null, mixedCurrency: true };
  }
  return {
    count,
    revenue,
    currency: summary.currency || null,
    mixedCurrency: false,
  };
}
